import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element not found");
}

createRoot(rootEl).render(<App />);

if (typeof window !== "undefined") {
  // Load Google Fonts asynchronously with hard timeout — if blocked/slow (e.g. some BD ISPs),
  // the page still renders fully with the system font stack defined in index.html.
  const loadFonts = () => {
    try {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href =
        "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Noto+Sans+Bengali:wght@400;700&display=swap";
      link.media = "print";
      let settled = false;
      const finalize = (apply: boolean) => {
        if (settled) return;
        settled = true;
        if (apply) link.media = "all";
      };
      link.onload = () => finalize(true);
      link.onerror = () => finalize(false);
      // Hard 4s timeout — if Google Fonts hasn't responded, give up silently.
      globalThis.setTimeout(() => finalize(false), 4000);
      document.head.appendChild(link);
      import("./lib/performance").then((module) => module.loadDeferredFonts()).catch(() => {});
    } catch {
      /* ignore — system fonts will be used */
    }
  };

  window.addEventListener(
    "load",
    () => {
      if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(loadFonts, { timeout: 3000 });
        return;
      }
      globalThis.setTimeout(loadFonts, 2500);
    },
    { once: true },
  );
}
